module.exports = __webpack_public_path__ + "img/special2-2.8823c37e.png";